module.exports = __webpack_public_path__ + "img/brand--sap.3618180f.svg";